import {type ReactNode, useLayoutEffect, useRef} from "react";
import {css, cx} from "@panda/css";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    children: (overlayRef: React.RefObject<HTMLDivElement | null>) => ReactNode;
}

export const SemanticSearchFullscreenOverlay = ({isOpen, onClose, children}: Props) => {
    const overlayRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (!isOpen || !overlayRef.current) return;

        const element = overlayRef.current;
        element.scrollTop = element.scrollHeight;
    }, [isOpen]);

    useLayoutEffect(() => {
        if (!isOpen) return;

        const previousOverflow = document.body.style.overflow;
        const previousOverscrollBehavior = document.body.style.overscrollBehavior;

        document.body.style.overflow = "hidden";
        document.body.style.overscrollBehavior = "none";

        return () => {
            document.body.style.overflow = previousOverflow;
            document.body.style.overscrollBehavior = previousOverscrollBehavior;
        };
    }, [isOpen]);

    useLayoutEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    return (
        <div className={cx(root, !isOpen && rootHidden)} role="dialog" aria-modal="true" aria-label="Asystent AI" aria-hidden={!isOpen}>
            <div ref={overlayRef} className={overlay} data-testid="ai-advisor-modal">
                {children(overlayRef)}
            </div>
        </div>
    );
};

const root = css({
    position: "fixed",
    inset: 0,
    zIndex: 9000
});

const rootHidden = css({
    visibility: "hidden",
    pointerEvents: "none",
    opacity: 0,
    transition: "none"
});

const overlay = css({
    boxSizing: "border-box",
    width: "100%",
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    overflow: "auto",
    overscrollBehavior: "contain",
    background: "var(--colors-background-100)"
});
import {type ReactNode, useLayoutEffect, useRef} from "react";
import {css, cx} from "@panda/css";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    children: (overlayRef: React.RefObject<HTMLDivElement | null>) => ReactNode;
}

export const SemanticSearchFullscreenOverlay = ({isOpen, onClose, children}: Props) => {
    const overlayRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (!isOpen || !overlayRef.current) return;

        const element = overlayRef.current;
        element.scrollTop = element.scrollHeight;
    }, [isOpen]);

    useLayoutEffect(() => {
        if (!isOpen) return;

        const previousOverflow = document.body.style.overflow;
        const previousOverscrollBehavior = document.body.style.overscrollBehavior;

        document.body.style.overflow = "hidden";
        document.body.style.overscrollBehavior = "none";

        return () => {
            document.body.style.overflow = previousOverflow;
            document.body.style.overscrollBehavior = previousOverscrollBehavior;
        };
    }, [isOpen]);

    useLayoutEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    return (
        <div className={cx(root, !isOpen && rootHidden)} role="dialog" aria-modal="true" aria-label="Asystent AI" aria-hidden={!isOpen}>
            <div ref={overlayRef} className={overlay} data-testid="ai-advisor-modal">
                {children(overlayRef)}
            </div>
        </div>
    );
};

const root = css({
    position: "fixed",
    inset: 0,
    zIndex: 9000
});

const rootHidden = css({
    visibility: "hidden",
    pointerEvents: "none",
    opacity: 0,
    transition: "none"
});

const overlay = css({
    boxSizing: "border-box",
    width: "100%",
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    overflow: "auto",
    overscrollBehavior: "contain",
    background: "var(--colors-background-100)"
});
